import Footer from "../../components/Footer";
import Header from "../../components/Header";
import "@fontsource/oswald";
import HeaderBlue from "../../components/HeaderBlue";
import FooterBlue from "../../components/FooterBlue";

const ContactUs = () => {
    return (
        <div className="flex flex-col min-h-screen">
            <HeaderBlue />
            {/* Contact Banner Section */}
            <section className="w-full py-60 relative bg-cover bg-center px-3"
                style={{
                    backgroundImage: "url('./assets/contactus1.webp')",
                    backgroundSize: 'cover',
                    // backgroundPosition: 'center'
                }}>
                <div className="absolute inset-0 bg-gradient-to-r from-black/80 to-white/10 z-0"></div>
                <div className="md:px-40 relative z-10">
                    <h2 className="text-white text-6xl font-oswald drop-shadow-lg pb-5">CONTACT US</h2>
                    <p className="text-white text-xl font-semibold font-oswald mt-2">
                        We're here to help! Reach out with your questions, feedback, or support requests.
                    </p>
                </div>
            </section>

            {/* Contact Form & Info Section */}
            <main className="max-w-6xl mx-auto mt-10 px-5">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
                    {/* Form */}
                    <form className="bg-white p-8 rounded-lg shadow-md">
                        <label htmlFor="name" className="block mb-2 font-semibold">Full Name</label>
                        <input type="text" id="name" placeholder="Enter your name" required className="w-full p-3 mb-5 border border-gray-300 rounded-md text-base" />

                        <label htmlFor="email" className="block mb-2 font-semibold">Email Address</label>
                        <input type="email" id="email" placeholder="Enter your email" required className="w-full p-3 mb-5 border border-gray-300 rounded-md text-base" />

                        <label htmlFor="message" className="block mb-2 font-semibold">Your Message</label>
                        <textarea id="message" rows="6" placeholder="Type your message..." required className="w-full p-3 mb-5 border border-gray-300 rounded-md text-base"></textarea>

                        <button type="submit" className="bg-[#3c9bf9] text-white px-6 py-3 rounded-md text-base font-semibold hover:bg-black transition duration-300">Send Message</button>
                    </form>

                    {/* Contact Info */}
                    <div className="bg-white p-8 rounded-lg shadow-sm">
                        <h2 className="text-[#3c9bf9] text-2xl mb-5">Get in Touch</h2>
                        {/* <p className="mb-3 text-gray-900 text-base"><i className="fas fa-phone-alt mr-2"></i> +968 24 564000</p> */}
                        <p className="mb-3 text-gray-900 text-base"><i className="fas fa-envelope mr-2"></i> <a href="mailto:support@fleetycdl.com">support@fleetycdl.com</a></p>
                        <p className="mb-3 text-gray-900 text-base"><i className="fas fa-clock mr-2"></i> Mon - Fri: 9:00 - 18:00</p>
                    </div>
                </div>
            </main>
            <FooterBlue />
        </div>
    );
};

export default ContactUs;
